/**
 * Riparazione dei file media scaricati da WAHA (28/09/2026).
 *
 * Le foto inviate da API (dal CRM o dal numero Ufficiale, id che iniziano con 3EB0) vengono
 * salvate da WAHA NOWEB con 15 byte estranei prima dell'intestazione JPEG: il browser non le
 * apre e nella chat compare un riquadro rotto. Le foto mandate dal telefono sono integre.
 * Se l'intestazione di un formato noto compare poco dopo l'inizio, si tagliano i byte in testa.
 */

const MAX_OFFSET = 32;

type Signature = { bytes: number[]; at: number };

// "at" = posizione dell'intestazione dentro il file integro (MP4 ha "ftyp" al byte 4).
const SIGNATURES: Signature[] = [
  { bytes: [0xff, 0xd8, 0xff], at: 0 }, // JPEG
  { bytes: [0x89, 0x50, 0x4e, 0x47], at: 0 }, // PNG
  { bytes: [0x52, 0x49, 0x46, 0x46], at: 0 }, // RIFF (WEBP)
  { bytes: [0x47, 0x49, 0x46, 0x38], at: 0 }, // GIF
  { bytes: [0x66, 0x74, 0x79, 0x70], at: 4 }, // MP4 / MOV
];

function matchesAt(data: Uint8Array, pos: number, sig: number[]): boolean {
  if (pos < 0 || pos + sig.length > data.length) return false;
  for (let i = 0; i < sig.length; i++) if (data[pos + i] !== sig[i]) return false;
  return true;
}

/** Quanti byte estranei ci sono in testa (0 se il file e' integro o sconosciuto). */
export function junkPrefixLength(data: Uint8Array): number {
  for (const sig of SIGNATURES) {
    if (matchesAt(data, sig.at, sig.bytes)) return 0;
  }
  for (let offset = 1; offset <= MAX_OFFSET; offset++) {
    for (const sig of SIGNATURES) {
      if (matchesAt(data, offset + sig.at, sig.bytes)) return offset;
    }
  }
  return 0;
}

/** Restituisce il blob senza i byte estranei in testa, oppure quello originale. */
export async function repairMediaBlob(blob: Blob): Promise<Blob> {
  if (!blob.type.startsWith('image/') && !blob.type.startsWith('video/')) return blob;
  const head = new Uint8Array(await blob.slice(0, MAX_OFFSET + 8).arrayBuffer());
  const junk = junkPrefixLength(head);
  return junk > 0 ? blob.slice(junk, blob.size, blob.type) : blob;
}
